import { UsageTracker } from '@patsnap/synapse_domain'
import { E_ROUTER_NAME } from '@pharmsnap/pharmsnap-web/types/enum'
import { getLocaleLang } from '@pharmsnap/pharmsnap-web/utils/business/locale'
import { bizEvent } from '@pharmsnap/shared/src/features/biz-event'
import { trackingEvent } from '@pharmsnap/shared/src/features/tracking'
import { showSingleToast } from '@pharmsnap/shared/src/utils'
import { getTextByLang } from '@pharmsnap/shared/src/utils/lang'
import VueRouter from 'vue-router'
interface FreemiumCompleteUserinfoConfig {
  userId: string
  router: VueRouter
}
export class FreemiumCompleteUserinfo {
  _config: FreemiumCompleteUserinfoConfig | null = null
  usageTracker: UsageTracker<{
    search: number
    viewDetail: number
  }> | null = null
  ls360UsageTracker: UsageTracker<{
    chat: number
    chatDeep: number
  }> | null = null
  constructor(private config: FreemiumCompleteUserinfoConfig) {
    // 用户信息完整则不需要添加监听
    this.usageTracker = new UsageTracker({
      userId: this.config.userId,
      period: 'month',
      limitCounts: {
        search: 3,
        viewDetail: 10,
      },
      onLimitReached: () => {
        this.gotoCompleteUserInfo()
      },
      store: window.localStorage,
    })
    this.ls360UsageTracker = new UsageTracker({
      userId: this.config.userId,
      period: 'day',
      storageKey: 'ls360UsageTracker',
      limitCounts: {
        chat: 5,
        chatDeep: 2,
      },
      onLimitReached: () => {
        this.gotoCompleteUserInfo()
      },
      store: window.localStorage,
    })
    trackingEvent.$bus.$on('ACTIVE_SEARCH', () => {
      this.usageTracker?.trackUsage('search')
    })
    bizEvent.on('VIEW_DETAIL', () => {
      this.usageTracker?.trackUsage('viewDetail')
    })
  }

  public gotoCompleteUserInfo() {
    const lang = getLocaleLang()
    showSingleToast({
      type: 'info',
      duration: 5000,
      message: getTextByLang(
        {
          cn: '体验用量已达到,请补充个人信息获,立刻开启更多免费权限。',
          en: 'Trial capacity reached. Please complete your personal information to unlock additional free privileges.',
          jp: '試用可能な回数に達しました。個人情報を入力すると、さらに無料の権限をご利用いただけます。',
        },
        lang
      ),
    })
    trackingEvent('TRIGGER_COMPLETE_INFO')
    setTimeout(() => {
      this.config.router.push({
        name: E_ROUTER_NAME.COMPLETE_INFO,
        query: {
          redirectUrl: window.location.href,
        },
      })
    }, 300)
  }

  static ins: FreemiumCompleteUserinfo

  static getSingleton(config?: FreemiumCompleteUserinfoConfig) {
    if (FreemiumCompleteUserinfo.ins) {
      return FreemiumCompleteUserinfo.ins
    }
    if (!config) {
      throw new Error('FreemiumCompleteUserinfo need config')
    }
    return (FreemiumCompleteUserinfo.ins = new FreemiumCompleteUserinfo(config))
  }
}
